const hasAccessTo = (userGroups: string[], requiredGroups: string | string[]): boolean => {
  if (!userGroups || (typeof requiredGroups === "string" && !requiredGroups)) return false;

  const requiredGroupsArray = typeof requiredGroups === "string" ? [requiredGroups] : requiredGroups;

  return requiredGroupsArray.some((group) => userGroups.includes(group));
};

export { hasAccessTo };
